module.exports = __webpack_public_path__ + "img/imagotipo.9552505a.svg";